import React, { FC, HTMLAttributes } from 'react'
import styles from './Divider.module.scss'
interface DividerTypeProps extends HTMLAttributes<HTMLHRElement> {
  variant?: 'fullWidth' | 'middle'
  orientation?: 'horizontal' | 'vertical'
  className?: string
}

const Divider: FC<DividerTypeProps> = ({
  variant = 'fullWidth',
  orientation = 'horizontal',
  className = '',
  ...props
}) => {
  return (
    <hr
      {...props}
      className={`
        ${styles['divider-class']} 
        ${styles[variant]}
        ${styles[orientation]} 
        ${className}
      `}
    />
  )
}

export default Divider
